module.exports = __webpack_public_path__ + "img/bust dart to bust dart.5a9c1d46.png";